export const UpArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
        <path d="M7 14l5-5 5 5z" fill="currentColor" />
    </svg>
);

export const DownArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
        <path d="M7 10l5 5 5-5z" fill="currentColor" />
    </svg>
);

export const PoweBank = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
        imageRendering="optimizeQuality"
        fillRule="evenodd"
        clipRule="evenodd"
        viewBox="0 0 50 50"
        width="20"
        height="20">
        <path d="M65.93 386.1h326.13c9.14 0 18.92 2.1 27.79 5.83 5.08 2.14 9.9 4.85 14.21 8.06L399.49 85.97c-1.81-19.19-10-36.67-22.7-49.11-11.77-11.57-27.56-18.73-45.77-18.73H124.99c-17.89 0-33.34 6.92-45 18.13l-.44.46C66.83 49.19 58.59 66.76 56.52 86.07L22.84 400.71c4.9-3.85 10.61-7.04 16.64-9.41 8.45-3.33 17.76-5.2 26.45-5.2zm4.69 48.93h69.49c2.53 0 4.6 2.08 4.6 4.6v18.74c0 2.53-2.08 4.6-4.6 4.6H70.62c-2.52 0-4.6-2.07-4.6-4.6v-18.74c0-2.53 2.07-4.6 4.6-4.6zm163.32 3.55c0 3.1-2.51 5.61-5.61 5.61-3.1 0-5.61-2.51-5.61-5.61v-16.73c0-3.1 2.51-5.61 5.61-5.61 3.1 0 5.61 2.51 5.61 5.61v16.73zm9.84-2.51a5.591 5.591 0 0 1 .57-7.89c2.33-2.02 5.87-1.77 7.88.57 2.43 2.81 4.38 6.07 5.7 9.63 1.28 3.46 1.99 7.17 1.99 10.99 0 8.71-3.54 16.6-9.25 22.32-5.74 5.73-13.63 9.27-22.34 9.27-8.72 0-16.62-3.54-22.33-9.25-5.72-5.72-9.26-13.61-9.26-22.34 0-3.76.68-7.41 1.92-10.8a31.47 31.47 0 0 1 5.52-9.52 5.578 5.578 0 0 1 7.86-.67c2.36 1.98 2.66 5.5.68 7.86-1.51 1.8-2.72 3.87-3.55 6.14-.78 2.15-1.21 4.51-1.21 6.99 0 5.63 2.29 10.73 5.97 14.41 3.68 3.68 8.77 5.96 14.4 5.96a20.328 20.328 0 0 0 20.37-20.37c0-2.54-.44-4.93-1.25-7.09-.84-2.29-2.1-4.39-3.67-6.21zm75.4-1.04h69.49c2.53 0 4.6 2.07 4.6 4.6v18.74c0 2.53-2.07 4.6-4.6 4.6h-69.49c-2.52 0-4.6-2.07-4.6-4.6v-18.74c0-2.53 2.07-4.6 4.6-4.6zm137.35.42c1.59 7.2 1.88 14.59.92 21.81-1.97 14.72-9.11 28.77-21.08 39.15a65.131 65.131 0 0 1-6.35 4.85c-5.15 3.44-11.52 6.1-18.03 7.86-6.64 1.8-13.72 2.78-19.93 2.78H65.93c-8.7 0-18.09-1.92-26.67-5.34-8.53-3.4-16.41-8.42-22.29-14.7C5.6 479.7-.06 464.23 0 448.82v-.06c.01-2.71-.01-7.81.26-10.42L38.17 84.23c2.52-23.5 12.64-44.99 28.3-60.33l.55-.5C82.03 8.94 101.93 0 124.99 0h206.03c23.39 0 43.67 9.2 58.82 24.04h.03c15.64 15.32 25.71 36.72 27.96 60.16l38.7 351.25zM29.1 480.52c8.42 9 23.62 14.69 36.83 14.69h326.13c9.39 0 21.39-2.89 28.7-7.78 21.97-14.68 25.73-49.71 9.31-68.64-8.46-9.76-24.12-16-38.01-16H65.93c-13.13 0-28.17 5.58-36.58 14.43-16.07 16.92-16.1 46.36-.25 63.3zm218.64-285.13h25.83c3.76.02 6.79 3.07 6.79 6.82 0 1.34-.4 2.66-1.15 3.77l-61.57 105.16a6.796 6.796 0 0 1-5.79 3.25 6.79 6.79 0 0 1-6.79-6.79c0-.44.05-.88.13-1.31l9.09-64.54-30.65.52h-.11c-3.69 0-6.7-2.96-6.77-6.65v-.03c0-1.23.33-2.44.94-3.52l60.64-105.13a6.775 6.775 0 0 1 5.81-3.28 6.78 6.78 0 0 1 6.78 6.78c0 .3-.01.6-.05.89l-3.13 64.06z" />
    </svg>
);

export const AznIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.0"
        width="30"
        height="25"
        viewBox="0 0 450 370"
        id="svg5730"
    >
        <defs id="defs5733" />
        <path
            d="M 200.2122,345.46419 L 210.02653,14.721485 L 242.41379,0.98143236 L 246.33952,318.96552 L 200.2122,345.46419 z"
            style={{
                fill: 'white',
                fillRule: 'evenodd',
                stroke: 'white',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                strokeOpacity: 1,
            }}
            id="path5739"
        />
        <path
            d="M 0,365.09284 L 45.145889,367.0557 C 46.017036,146.43188 164.4644,73.686678 222.78515,71.644562 C 380.37338,76.675026 398.43702,278.1629 404.35013,367.0557 L 449.49602,369.01857 C 446.09975,156.05299 329.3806,39.218552 233.5809,41.220159 C 70.232046,46.977749 8.0205414,213.70543 0,365.09284 z"
            style={{
                fill: 'white',
                fillRule: 'evenodd',
                stroke: 'white',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                strokeOpacity: 1,
            }}
            id="path5764"
        />
    </svg>
);